import { render, staticRenderFns } from "./redeemCodeList.vue?vue&type=template&id=2c5fd098&scoped=true&"
import script from "./redeemCodeList.vue?vue&type=script&lang=js&"
export * from "./redeemCodeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5fd098",
  null
  
)

export default component.exports